import React from 'react';
import {
    Restaurant,
    ShoppingBag,
    Home,
    DirectionsCar,
    HealthAndSafety,
    School,
    TheaterComedy,
    Flight,
    Handyman,
    Bolt,
    WaterDrop,
    Wifi,
    Phone,
    RequestQuote,
    ShoppingCart,
    Category,
    LocalGroceryStore,
    Movie,
    FitnessCenter,
    Coffee,
    ReceiptLong,
    MoreHoriz,
    LocalDining,
    Fastfood,
    LocalCafe,
    LocalBar,
    LocalGasStation,
    SmokingRooms,
    Whatshot,
    Train,
    DirectionsBus,
    TwoWheeler,
    Build,
    ElectricBolt,
    LocalPharmacy,
    LocalHospital,
    SportsEsports,
    MusicNote,
    Book,
    Pets,
    ChildCare,
    Work,
    AttachMoney,
    AccountBalance,
    CreditCard,
    Savings,
    ShoppingCartOutlined,
    Store,
    Storefront,
    LocalMall,
    LocalOffer,
    LocalAtm,
    Payment,
    Receipt,
    Description,
    Note,
    CheckCircle,
    Cancel,
    Add,
    Remove,
    Edit,
    Delete,
    Settings,
    Star,
    Favorite,
    FavoriteBorder
} from '@mui/icons-material';

const iconMap: { [key: string]: React.ReactElement } = {
    // Portuguese
    'Restaurante': <Restaurant fontSize="small" />,
    'Alimentação': <Restaurant fontSize="small" />,
    'Supermercado': <LocalGroceryStore fontSize="small" />,
    'Compras': <ShoppingBag fontSize="small" />,
    'Casa': <Home fontSize="small" />,
    'Transporte': <DirectionsCar fontSize="small" />,
    'Saúde': <HealthAndSafety fontSize="small" />,
    'Educação': <School fontSize="small" />,
    'Lazer': <TheaterComedy fontSize="small" />,
    'Viagens': <Flight fontSize="small" />,
    'Manutenção': <Handyman fontSize="small" />,
    'Eletricidade': <Bolt fontSize="small" />,
    'Água': <WaterDrop fontSize="small" />,
    'Internet': <Wifi fontSize="small" />,
    'Telemóvel': <Phone fontSize="small" />,
    'Impostos': <RequestQuote fontSize="small" />,
    'Serviços': <Handyman fontSize="small" />,
    'Cinema': <Movie fontSize="small" />,
    'Ginásio': <FitnessCenter fontSize="small" />,
    'Café': <Coffee fontSize="small" />,
    'Renda': <ReceiptLong fontSize="small" />,
    'Gás': <LocalGasStation fontSize="small" />,
    'Tabaco': <SmokingRooms fontSize="small" />,

    // English
    'Restaurant': <Restaurant fontSize="small" />,
    'Food': <Restaurant fontSize="small" />,
    'Grocery': <LocalGroceryStore fontSize="small" />,
    'Shopping': <ShoppingBag fontSize="small" />,
    'Home': <Home fontSize="small" />,
    'Transport': <DirectionsCar fontSize="small" />,
    'Health': <HealthAndSafety fontSize="small" />,
    'Education': <School fontSize="small" />,
    'Leisure': <TheaterComedy fontSize="small" />,
    'Travel': <Flight fontSize="small" />,
    'Maintenance': <Handyman fontSize="small" />,
    'Electricity': <Bolt fontSize="small" />,
    'Water': <WaterDrop fontSize="small" />,
    'Mobile': <Phone fontSize="small" />,
    'Taxes': <RequestQuote fontSize="small" />,
    'Services': <Handyman fontSize="small" />,
    'Movie': <Movie fontSize="small" />,
    'Gym': <FitnessCenter fontSize="small" />,
    'Coffee': <Coffee fontSize="small" />,
    'Rent': <ReceiptLong fontSize="small" />,
    'Gas': <LocalGasStation fontSize="small" />,
    'Tobacco': <SmokingRooms fontSize="small" />,
    'Others': <MoreHoriz fontSize="small" />,
    'Outros': <MoreHoriz fontSize="small" />,
};

// Map of icon names to React components
export const iconNameMap: { [key: string]: React.ReactElement } = {
    'Restaurant': <Restaurant fontSize="small" />,
    'ShoppingBag': <ShoppingBag fontSize="small" />,
    'Home': <Home fontSize="small" />,
    'DirectionsCar': <DirectionsCar fontSize="small" />,
    'HealthAndSafety': <HealthAndSafety fontSize="small" />,
    'School': <School fontSize="small" />,
    'TheaterComedy': <TheaterComedy fontSize="small" />,
    'Flight': <Flight fontSize="small" />,
    'Handyman': <Handyman fontSize="small" />,
    'Bolt': <Bolt fontSize="small" />,
    'WaterDrop': <WaterDrop fontSize="small" />,
    'Wifi': <Wifi fontSize="small" />,
    'Phone': <Phone fontSize="small" />,
    'RequestQuote': <RequestQuote fontSize="small" />,
    'ShoppingCart': <ShoppingCart fontSize="small" />,
    'Category': <Category fontSize="small" />,
    'LocalGroceryStore': <LocalGroceryStore fontSize="small" />,
    'Movie': <Movie fontSize="small" />,
    'FitnessCenter': <FitnessCenter fontSize="small" />,
    'Coffee': <Coffee fontSize="small" />,
    'ReceiptLong': <ReceiptLong fontSize="small" />,
    'MoreHoriz': <MoreHoriz fontSize="small" />,
    'LocalDining': <LocalDining fontSize="small" />,
    'Fastfood': <Fastfood fontSize="small" />,
    'LocalCafe': <LocalCafe fontSize="small" />,
    'LocalBar': <LocalBar fontSize="small" />,
    'LocalGasStation': <LocalGasStation fontSize="small" />,
    'SmokingRooms': <SmokingRooms fontSize="small" />,
    'Whatshot': <Whatshot fontSize="small" />,
    'Train': <Train fontSize="small" />,
    'DirectionsBus': <DirectionsBus fontSize="small" />,
    'TwoWheeler': <TwoWheeler fontSize="small" />,
    'Build': <Build fontSize="small" />,
    'ElectricBolt': <ElectricBolt fontSize="small" />,
    'LocalPharmacy': <LocalPharmacy fontSize="small" />,
    'LocalHospital': <LocalHospital fontSize="small" />,
    'SportsEsports': <SportsEsports fontSize="small" />,
    'MusicNote': <MusicNote fontSize="small" />,
    'Book': <Book fontSize="small" />,
    'Pets': <Pets fontSize="small" />,
    'ChildCare': <ChildCare fontSize="small" />,
    'Work': <Work fontSize="small" />,
    'AttachMoney': <AttachMoney fontSize="small" />,
    'AccountBalance': <AccountBalance fontSize="small" />,
    'CreditCard': <CreditCard fontSize="small" />,
    'Savings': <Savings fontSize="small" />,
    'ShoppingCartOutlined': <ShoppingCartOutlined fontSize="small" />,
    'Store': <Store fontSize="small" />,
    'Storefront': <Storefront fontSize="small" />,
    'LocalMall': <LocalMall fontSize="small" />,
    'LocalOffer': <LocalOffer fontSize="small" />,
    'LocalAtm': <LocalAtm fontSize="small" />,
    'Payment': <Payment fontSize="small" />,
    'Receipt': <Receipt fontSize="small" />,
    'Description': <Description fontSize="small" />,
    'Note': <Note fontSize="small" />,
    'CheckCircle': <CheckCircle fontSize="small" />,
    'Cancel': <Cancel fontSize="small" />,
    'Add': <Add fontSize="small" />,
    'Remove': <Remove fontSize="small" />,
    'Edit': <Edit fontSize="small" />,
    'Delete': <Delete fontSize="small" />,
    'Settings': <Settings fontSize="small" />,
    'Star': <Star fontSize="small" />,
    'Favorite': <Favorite fontSize="small" />,
    'FavoriteBorder': <FavoriteBorder fontSize="small" />,
};

// Export list of available icon names for selection
export const availableIconNames = Object.keys(iconNameMap);

export const getCategoryIcon = (category: string, customIcons?: { [key: string]: string }): React.ReactElement => {
    // First check for custom icon
    if (customIcons && customIcons[category] && iconNameMap[customIcons[category]]) {
        return iconNameMap[customIcons[category]];
    }

    // Try exact match first
    if (iconMap[category]) return iconMap[category];

    // Try case-insensitive search
    const lowerCategory = category.toLowerCase();
    const foundKey = Object.keys(iconMap).find(key => key.toLowerCase() === lowerCategory);
    if (foundKey) return iconMap[foundKey];

    // Try partial mapping for common patterns
    if (lowerCategory.includes('restaurante') || lowerCategory.includes('comida') || lowerCategory.includes('food')) return <Restaurant fontSize="small" />;
    if (lowerCategory.includes('supermercado') || lowerCategory.includes('pingo') || lowerCategory.includes('continente') || lowerCategory.includes('grocery')) return <LocalGroceryStore fontSize="small" />;
    if (lowerCategory.includes('carro') || lowerCategory.includes('transporte') || lowerCategory.includes('uber') || lowerCategory.includes('gasolin')) return <DirectionsCar fontSize="small" />;
    if (lowerCategory.includes('casa') || lowerCategory.includes('home') || lowerCategory.includes('aluguer')) return <Home fontSize="small" />;
    if (lowerCategory.includes('saude') || lowerCategory.includes('farmacia') || lowerCategory.includes('health')) return <HealthAndSafety fontSize="small" />;
    if (lowerCategory.includes('compras') || lowerCategory.includes('shopping') || lowerCategory.includes('loja')) return <ShoppingBag fontSize="small" />;
    if (lowerCategory.includes('gás') || lowerCategory.includes('gas') || lowerCategory.includes('gasolin')) return <LocalGasStation fontSize="small" />;
    if (lowerCategory.includes('tabaco') || lowerCategory.includes('tobacco') || lowerCategory.includes('cigarro') || lowerCategory.includes('cigarette')) return <SmokingRooms fontSize="small" />;

    // Default icon
    return <Category fontSize="small" />;
};
